import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'thirdPartyProviders',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  getURL: 'mainHubs/mainHubId/configId/thirdPartyProviders',
  sessionParams: ['mainHubId', 'configId'],
  emptyMessage: "You don't have third party provider, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the provider.',
    },
    {
      attributeName: 'appName',
      label: 'App',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the App.',
    },
  ],
};
